// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__16PVN","inputWrap":"Table_inputWrap__2niyR","col":"Table_col__22P69","bmiTooltip":"Table_bmiTooltip__38Ldt"};